import { useContext } from 'react';

import { MultiStepContext } from './MultiStep';

const useMultiStep = () => {
  const context = useContext(MultiStepContext);
  if (!context) {
    throw new Error('useMultiStep must be used within a MultiStepProvider');
  }
  return context;
};

export default useMultiStep;
